var render, staticRenderFns
import script from "./transactionsDetail.vue?vue&type=script&lang=js&"
export * from "./transactionsDetail.vue?vue&type=script&lang=js&"
import style0 from "./transactionsDetail.vue?vue&type=style&index=0&id=1fa5a206&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa5a206",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/zklink/web/zklink-explorer-web-build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fa5a206')) {
      api.createRecord('1fa5a206', component.options)
    } else {
      api.reload('1fa5a206', component.options)
    }
    
  }
}
component.options.__file = "src/views/index/transactionsDetail.vue"
export default component.exports